export const sensitiveFields = [
    'domain',
    'podId',
    'mfsServiceDomain',
    'specifiedDomain',
    'podName',
    'podFileName',
    'folderPath',
    'driveId',
    'odspUrl',
    'error',
    'label',
    'labelId',
    'changedProperties',
    'previousCollectionLabel',
    `type`,
    'attributes',
];
/** Removes known sensitive fields that contain OII or CC from the given loggerParams */
export function removeSensitiveFields(input) {
    if (!input) {
        return input;
    }
    sensitiveFields.forEach((field) => delete input[field]);
    return input;
}
//# sourceMappingURL=compliance.js.map